import { render, staticRenderFns } from "./UserStatistics.vue?vue&type=template&id=76a1d500"
import script from "./UserStatistics.vue?vue&type=script&lang=js"
export * from "./UserStatistics.vue?vue&type=script&lang=js"
import style0 from "./UserStatistics.vue?vue&type=style&index=0&id=76a1d500&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports